export * from "p-timeout";
export { default } from "p-timeout";
